import { render, staticRenderFns } from "./lightboxSlider.vue?vue&type=template&id=b0b874b2&scoped=true&"
import script from "./lightboxSlider.vue?vue&type=script&lang=ts&"
export * from "./lightboxSlider.vue?vue&type=script&lang=ts&"
import style0 from "./lightboxSlider.vue?vue&type=style&index=0&id=b0b874b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b874b2",
  null
  
)

export default component.exports